/* eslint-disable no-undef */
export default {
	name: "dispense-fuel-form",
	props: ["orderNumber", "vehicleRegistration", "orderCollection", "orderItems"],
	emits: ["dispensementCompleted"],
	data() {
		return {
			collectionOrder: {},
			orderItemsForDispensing: [],
			orderItemsDispensed: [],
			pumps: [],
			fuelDispensement:{
				orderNumber: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				vehicleRegistration: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				odometerReading: {
					value: null,
					hasError: false,
					errorMessage: null
				}
			},
			orderItemsDispensedErrorMessage: null,
			successMessage:{
				message: "Fuel dispensement validated successfully.",
				showSuccessMessage: false
			},
			errorMessage:{
				message: "Fuel dispensement validation failed.",
				showErrorMessage: false
			},
			errorModal:{
				modalHeading: "Error",
				elementId: "dispenseFuelModalError",
				modalMessage: "",
				showModal: false
			},
			successModal:{
				modalHeading: "Success",
				elementId: "dispenseFuelModalSuccess",
				modalMessage: "",
				showModal: false
			},
			loading: false,
			loadingFromApi: false,
			hasError: false
		};
	},
	methods: {
		getCollectionOrder(){
			// this.collectionOrder = {
			// 	orderId: 1,
			// 	collectionCode: "COL-001",
			// 	totalAmount: 1000,
			// 	discountedAmount: 10,
			// 	orderCollectionId: 1,
			// };
			this.collectionOrder.totalAmountDispensed = 0;
			this.collectionOrder.totalQuantityDispensed = 0;
			this.collectionOrder.totalAmount = this.collectionOrder.totalAmount - this.collectionOrder.discountedAmount;
			this.collectionOrder.totalAmountDispensedAsString = currencyHelper.numberToCurrency(this.collectionOrder.totalAmountDispensed);
			this.collectionOrder.totalAmountAsString = currencyHelper.numberToCurrency(this.collectionOrder.totalAmount);
			this.getPumpsForDepot();
			this.getOrderItems();
		},
		getOrderItems(){
			this.orderItemsDispensed = [];
			for(let i = 0; i < this.orderItemsForDispensing.length; i++){
				this.orderItemsForDispensing[i].totalAmount = this.orderItemsForDispensing[i].totalAmount - (this.orderItemsForDispensing[i].discountedAmount * this.orderItemsForDispensing[i].quantity);
				this.orderItemsForDispensing[i].totalAmountDispensed = null;
				this.orderItemsForDispensing[i].discountedAmountDispensed = null;
				this.orderItemsForDispensing[i].unitPriceAsString = currencyHelper.numberToCurrency(this.orderItemsForDispensing[i].unitPrice);
				this.orderItemsForDispensing[i].totalAmountAsString = currencyHelper.numberToCurrency(this.orderItemsForDispensing[i].totalAmount);
				this.orderItemsForDispensing[i].discountedAmountAsString = currencyHelper.numberToCurrency(this.orderItemsForDispensing[i].discountedAmount);
				this.orderItemsForDispensing[i].pumpReadingStart = null;
				this.orderItemsForDispensing[i].pumpReadingEnd = null;
				this.orderItemsForDispensing[i].pumpId = null;
				this.orderItemsForDispensing[i].totalAmountDispensedAsString = currencyHelper.numberToCurrency(this.orderItemsForDispensing[i].totalAmountDispensed);
				
				this.orderItemsDispensed.push({
					orderItemId: this.orderItemsForDispensing[i].orderItemId,
					orderId: this.orderItemsForDispensing[i].orderId,
					productId: this.orderItemsForDispensing[i].productId,
					product: this.orderItemsForDispensing[i].product,
					quantity: this.orderItemsForDispensing[i].quantity,
					unitPrice: this.orderItemsForDispensing[i].unitPrice,
					totalAmount: this.orderItemsForDispensing[i].totalAmount,
					discountedAmount: this.orderItemsForDispensing[i].discountedAmount,
					quantityDispensed: {
						value: this.orderItemsForDispensing[i].quantityDispensed,
						hasError: false,
						errorMessage: null
					},
					totalAmountDispensed: this.orderItemsForDispensing[i].totalAmountDispensed,
					discountedAmountDispensed: this.orderItemsForDispensing[i].discountedAmountDispensed,
					pumpReadingStart: {
						value: this.orderItemsForDispensing[i].pumpReadingStart,
						hasError: false,
						errorMessage: null
					},
					pumpReadingEnd: {
						value: this.orderItemsForDispensing[i].pumpReadingEnd,
						hasError: false,
						errorMessage: null
					},
					pumpId: {
						value: this.orderItemsForDispensing[i].pumpId,
						hasError: false,
						errorMessage: null
					},
					totalAmountDispensedAsString: this.orderItemsForDispensing[i].totalAmountDispensedAsString,
					unitPriceAsString: this.orderItemsForDispensing[i].unitPriceAsString,
					totalAmountAsString: this.orderItemsForDispensing[i].totalAmountAsString,
					discountedAmountAsString: this.orderItemsForDispensing[i].discountedAmountAsString,
				});
			}
		},
		getPumpsForDepot(){
			this.loading = true;
			let request = {
				depotId: this.collectionOrder.depotId,
				isActive: true
			}
			systemService.getAllDepotPumpsByDepotId(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if (isSuccess) {
						this.pumps = successResponse.data.result;
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.loading = false;
				}
			);
		},
		onPumpReadingStartInput(orderItemDispensed){
			if(orderItemDispensed.pumpReadingStart.value === null || orderItemDispensed.pumpReadingStart.value === undefined || orderItemDispensed.pumpReadingStart.value === "") {
				orderItemDispensed.pumpReadingStart.hasError = true;
				orderItemDispensed.pumpReadingStart.errorMessage = "Pump reading start is required.";
			}
			else if(orderItemDispensed.pumpReadingStart.value < 0){
				orderItemDispensed.pumpReadingStart.hasError = true;
				orderItemDispensed.pumpReadingStart.errorMessage = "Pump reading start cannot be less than zero";
			}
			else{
				orderItemDispensed.pumpReadingStart.hasError = false;
				orderItemDispensed.pumpReadingStart.errorMessage = null;
				if(orderItemDispensed.pumpReadingEnd.value !== null && orderItemDispensed.pumpReadingEnd.value !== undefined && orderItemDispensed.pumpReadingEnd.value !== ""){
					if(orderItemDispensed.pumpReadingStart.value < orderItemDispensed.pumpReadingEnd.value){
						orderItemDispensed.pumpReadingEnd.hasError = true;
						orderItemDispensed.pumpReadingEnd.errorMessage = "Pump reading start cannot be less than pump reading end.";
					}
					else{
						orderItemDispensed.pumpReadingEnd.hasError = false;
						orderItemDispensed.pumpReadingEnd.errorMessage = null;
						orderItemDispensed.quantityDispensed.value = orderItemDispensed.pumpReadingStart.value - orderItemDispensed.pumpReadingEnd.value;
						if(orderItemDispensed.quantityDispensed.value > orderItemDispensed.quantity || orderItemDispensed.quantityDispensed.value < 0) {
							orderItemDispensed.quantityDispensed.hasError = true;
							orderItemDispensed.quantityDispensed.errorMessage = "Quantity dispensed cannot be less than zero or greater than the quantity ordered.";
						}
					}
				}
			}
			this.onQuantityDispensedInput(orderItemDispensed);
		},
		onPumpReadingEndInput(orderItemDispensed){
			if(orderItemDispensed.pumpReadingEnd.value === null || orderItemDispensed.pumpReadingEnd.value === undefined || orderItemDispensed.pumpReadingEnd.value === "") {
				orderItemDispensed.pumpReadingEnd.hasError = true;
				orderItemDispensed.pumpReadingEnd.errorMessage = "Pump reading end is required.";
			}
			else if(orderItemDispensed.pumpReadingEnd.value < 0){
				orderItemDispensed.pumpReadingEnd.hasError = true;
				orderItemDispensed.pumpReadingEnd.errorMessage = "Pump reading end cannot be less than zero";
			}
			else{
				orderItemDispensed.pumpReadingEnd.hasError = false;
				orderItemDispensed.pumpReadingEnd.errorMessage = null;
				if(orderItemDispensed.pumpReadingStart.value !== null && orderItemDispensed.pumpReadingStart.value !== undefined && orderItemDispensed.pumpReadingStart.value !== ""){
					if(orderItemDispensed.pumpReadingStart.value < orderItemDispensed.pumpReadingEnd.value){
						orderItemDispensed.pumpReadingEnd.hasError = true;
						orderItemDispensed.pumpReadingEnd.errorMessage = "Pump reading start cannot be less than pump reading end.";
					}
					else{
						orderItemDispensed.pumpReadingEnd.hasError = false;
						orderItemDispensed.pumpReadingEnd.errorMessage = null;
						orderItemDispensed.quantityDispensed.value = orderItemDispensed.pumpReadingStart.value - orderItemDispensed.pumpReadingEnd.value;
						if(orderItemDispensed.quantityDispensed.value > orderItemDispensed.quantity || orderItemDispensed.quantityDispensed.value < 0) {
							orderItemDispensed.quantityDispensed.hasError = true;
							orderItemDispensed.quantityDispensed.errorMessage = "Quantity dispensed cannot be less than zero or greater than the quantity ordered.";
						}
					}
				}
			}
			this.onQuantityDispensedInput(orderItemDispensed);
		},
		onQuantityDispensedInput(orderItemDispensed){
			if(orderItemDispensed.quantityDispensed.value === null || orderItemDispensed.quantityDispensed.value === undefined || orderItemDispensed.quantityDispensed.value === ""){
				orderItemDispensed.quantityDispensed.hasError = true;
				orderItemDispensed.quantityDispensed.errorMessage = "Quantity dispensed is required.";
			}
			else{
				orderItemDispensed.quantityDispensed.hasError = false;
				orderItemDispensed.quantityDispensed.errorMessage = null;
			}
			
			// if(orderItemDispensed.quantityDispensed.value > orderItemDispensed.quantity || orderItemDispensed.quantityDispensed.value < 0) {
			// 	orderItemDispensed.quantityDispensed.value = 1;
			// }
			// var discountedAmountForSingleItem = 0;
			// if(orderItemDispensed.discountedAmount !== null && orderItemDispensed.discountedAmount > 0){
			// 	discountedAmountForSingleItem = orderItemDispensed.discountedAmount/orderItemDispensed.quantity;
			// }
			orderItemDispensed.discountedAmountDispensed = orderItemDispensed.quantityDispensed.value * orderItemDispensed.discountedAmount;
			orderItemDispensed.totalAmountDispensed = (orderItemDispensed.unitPrice * orderItemDispensed.quantityDispensed.value) - orderItemDispensed.discountedAmountDispensed;
			orderItemDispensed.totalAmountDispensedAsString = currencyHelper.numberToCurrency(orderItemDispensed.totalAmountDispensed);
			orderItemDispensed.discountedAmountDispensedAsString = currencyHelper.numberToCurrency(orderItemDispensed.discountedAmountDispensed);

			this.collectionOrder.totalQuantityDispensed = 0;
			this.collectionOrder.totalAmountDispensed = 0;
			for (let i = 0; i < this.orderItemsDispensed.length; i++) {
				this.collectionOrder.totalQuantityDispensed += this.orderItemsDispensed[i].quantityDispensed.value;
				this.collectionOrder.totalAmountDispensed += this.orderItemsDispensed[i].totalAmountDispensed;
				this.collectionOrder.totalAmountDispensedAsString = currencyHelper.numberToCurrency(this.collectionOrder.totalAmountDispensed);
				
			}
		},
		validateFuelDispensing(){
			let hasError = false;
			for(let i = 0; i < this.orderItemsDispensed.length; i++){
				if(this.orderItemsDispensed[i].quantityDispensed.value === null || this.orderItemsDispensed[i].quantityDispensed.value === undefined || this.orderItemsDispensed[i].quantityDispensed.value === ""){
					this.orderItemsDispensed[i].quantityDispensed.hasError = true;
					this.orderItemsDispensed[i].quantityDispensed.errorMessage = "Quantity dispensed is required.";
					hasError = true;
				}
				else{
					this.orderItemsDispensed[i].quantityDispensed.hasError = false;
					this.orderItemsDispensed[i].quantityDispensed.errorMessage = null;
					if(this.orderItemsDispensed[i].quantityDispensed.value > this.orderItemsDispensed[i].quantity || this.orderItemsDispensed[i].quantityDispensed.value < 0) {
						this.orderItemsDispensed[i].quantityDispensed.hasError = true;
						this.orderItemsDispensed[i].quantityDispensed.errorMessage = "Quantity dispensed cannot be less than zero or greater than the quantity ordered.";
						hasError = true;
					}
					else{
						this.orderItemsDispensed[i].quantityDispensed.hasError = false;
						this.orderItemsDispensed[i].quantityDispensed.errorMessage = null;
					}
				}
				
				if(this.orderItemsDispensed[i].pumpReadingStart.value === null || this.orderItemsDispensed[i].pumpReadingStart.value === undefined || this.orderItemsDispensed[i].pumpReadingStart.value === ""){
					this.orderItemsDispensed[i].pumpReadingStart.hasError = true;
					this.orderItemsDispensed[i].pumpReadingStart.errorMessage = "Pump reading start is required.";
					hasError = true;
				}
				else if(this.orderItemsDispensed[i].pumpReadingStart.value < 0){
					this.orderItemsDispensed[i].pumpReadingStart.hasError = true;
					this.orderItemsDispensed[i].pumpReadingStart.errorMessage = "Pump reading start cannot be less than zero";
					hasError = true;
				}
				else{
					this.orderItemsDispensed[i].pumpReadingStart.hasError = false;
					this.orderItemsDispensed[i].pumpReadingStart.errorMessage = null;
				}
				
				if(this.orderItemsDispensed[i].pumpReadingEnd.value === null || this.orderItemsDispensed[i].pumpReadingEnd.value === undefined || this.orderItemsDispensed[i].pumpReadingEnd.value === ""){
					this.orderItemsDispensed[i].pumpReadingEnd.hasError = true;
					this.orderItemsDispensed[i].pumpReadingEnd.errorMessage = "Pump reading end is required.";
					hasError = true;
				}
				else if(this.orderItemsDispensed[i].pumpReadingEnd.value < 0){
					this.orderItemsDispensed[i].pumpReadingStart.hasError = true;
					this.orderItemsDispensed[i].pumpReadingStart.errorMessage = "Pump reading end cannot be less than zero";
					hasError = true;
				}
				else{
					this.orderItemsDispensed[i].pumpReadingEnd.hasError = false;
					this.orderItemsDispensed[i].pumpReadingEnd.errorMessage = null;
				}
				
				if(this.orderItemsDispensed[i].pumpId.value === null || this.orderItemsDispensed[i].pumpId.value === undefined || this.orderItemsDispensed[i].pumpId.value === ""){
					this.orderItemsDispensed[i].pumpId.hasError = true;
					this.orderItemsDispensed[i].pumpId.errorMessage = "Pump is required.";
					hasError = true;
				}
				else{
					this.orderItemsDispensed[i].pumpId.hasError = false;
					this.orderItemsDispensed[i].pumpId.errorMessage = null;
				}

				if(this.orderItemsDispensed[i].pumpReadingStart.value < this.orderItemsDispensed[i].pumpReadingEnd.value){
					this.orderItemsDispensed[i].pumpReadingEnd.hasError = true;
					this.orderItemsDispensed[i].pumpReadingEnd.errorMessage = "Pump reading start cannot be less than pump reading end.";
					hasError = true;
				}
				else{
					this.orderItemsDispensed[i].pumpReadingEnd.hasError = false;
					this.orderItemsDispensed[i].pumpReadingEnd.errorMessage = null;
				}
				console.log("hasError", hasError);
				console.log("orderItemsDispensed[i]", this.orderItemsDispensed[i]);
			}
			if(!hasError){
				this.dispenseFuel();
			}
		},
		dispenseFuel() {
			this.loading = true;
			this.loadingFromApi = true;
			let orderItemsToDispense = [];
			for(let i = 0; i < this.orderItemsDispensed.length; i++){
				orderItemsToDispense.push({
					orderDispensedItemId: 0,
					orderItemId: this.orderItemsDispensed[i].orderItemId,
					quantity: this.orderItemsDispensed[i].quantityDispensed.value,
					pumpReadingStart: this.orderItemsDispensed[i].pumpReadingStart.value,
					pumpReadingEnd: this.orderItemsDispensed[i].pumpReadingEnd.value,
					depotPumpId: this.orderItemsDispensed[i].pumpId.value,
					totalAmount: this.orderItemsDispensed[i].totalAmountDispensed,
					discountedAmount: this.orderItemsDispensed[i].discountedAmountDispensed
				});
			}
			let request = {
				orderId: this.collectionOrder.orderId,
				companyId: this.collectionOrder.companyId,
				orderDispensedItems: orderItemsToDispense,
				vehicleOdometerReading: this.fuelDispensement.odometerReading.value,
				collectionCode: this.fuelDispensement.orderNumber.value,
				vehicleRegistration: this.fuelDispensement.vehicleRegistration.value
			};
			orderService.markCollectionOrderAsInPendingInvoice(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if (isSuccess) {
						if(successResponse.data.completeCollectionOrderValidationResponse.valuesAreValid){
							this.successModal.modalMessage = "Fuel dispensing completed successfully.";
							this.successModal.showModal = true;
						}
						else{
							this.fuelDispensement.orderNumber.hasError = successResponse.data.completeCollectionOrderValidationResponse.collectionCodeValidationResponse.hasError;
							this.fuelDispensement.orderNumber.errorMessage = successResponse.data.completeCollectionOrderValidationResponse.collectionCodeValidationResponse.message;

							this.fuelDispensement.vehicleRegistration.hasError = successResponse.data.completeCollectionOrderValidationResponse.vehicleRegistrationValidationResponse.hasError;
							this.fuelDispensement.vehicleRegistration.errorMessage = successResponse.data.completeCollectionOrderValidationResponse.vehicleRegistrationValidationResponse.message;

							this.fuelDispensement.odometerReading.hasError = successResponse.data.completeCollectionOrderValidationResponse.vehicleOdometerReadingValidationResponse.hasError;
							this.fuelDispensement.odometerReading.errorMessage = successResponse.data.completeCollectionOrderValidationResponse.vehicleOdometerReadingValidationResponse.message;
						
							this.orderItemsDispensedErrorMessage = successResponse.data.completeCollectionOrderValidationResponse.orderDispensedItemsDispensedValidationResponse.message;
						}
					}
					this.loading = false;
					this.loadingFromApi = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.loading = false;
					this.loadingFromApi = false;
				}
			);
		},
		successModelOkClicked(){
			this.successModal.showModal = false;
			this.$emit("dispensementCompleted", true);
		},
		errorModelOkClicked(){
			this.errorModal.showModal = false;
		},
		clearMessageAlerts(){
			//this.clearModel();
			this.successMessage ={
				message: "Fuel dispensement validated successfully.",
				showSuccessMessage: false
			};
			this.errorMessage = {
				message: "Fuel dispensement validation failed.",
				showErrorMessage: false
			};
		},
	},
	mounted: function () {
	},
	watch: {
		orderNumber:{
			handler: function () {
				console.log("orderNumber", this.orderNumber)
				if(this.orderNumber){
					this.fuelDispensement.orderNumber.value = this.orderNumber;
				}
			},
			immediate: true,
			deep: true
		},
		vehicleRegistration: {
			handler: function () {
				console.log("vehicleRegistration", this.vehicleRegistration)
				if (this.vehicleRegistration) {
					this.fuelDispensement.vehicleRegistration.value = this.vehicleRegistration;
				}
			},
			immediate: true,
			deep: true
		},
		orderCollection:{
			handler: function () {
				console.log("orderCollection", this.orderCollection)
				if (this.orderCollection) {
					this.collectionOrder = JSON.parse(JSON.stringify(this.orderCollection));
					this.getCollectionOrder();
				}
			},
			immediate: true,
			deep: true
		},
		orderItems: {
			handler: function () {
				console.log("orderItems", this.orderItems)
				if (this.orderItems !== null && this.orderItems !== undefined && this.orderItems.length > 0) {
					this.orderItemsForDispensing = JSON.parse(JSON.stringify(this.orderItems));
					this.getOrderItems();
				}
			},
			immediate: true,
			deep: true
		}
	}
};